var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogosAdminVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 193,
    height: 92,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00C1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#008EF3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "111.7%",
    height: "111.7%",
    x: "-5.9%",
    y: "-4.2%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "m125.869 37.456.025-9.398-6.699-.021a23.4 23.4 0 0 0-3.469-8.355l4.778-4.761-6.618-6.664-4.809 4.79a23.5 23.5 0 0 0-8.292-3.458l.017-6.804-9.386-.025-.017 6.808a23.5 23.5 0 0 0-8.31 3.411l-4.785-4.82-6.653 6.628 4.75 4.782a23.4 23.4 0 0 0-3.518 8.34l-6.695-.017-.025 9.398 6.74.022a23.3 23.3 0 0 0 3.449 8.333l-4.8 4.782 6.618 6.664 7.008-6.98v-8.497c-1.987-2.477-3.212-5.617-3.212-8.94 0-7.707 6.305-13.98 14.062-13.98 7.754 0 14.062 6.273 14.062 13.98 0 6.093-3.968 11.234-9.45 13.144V39.07c1.999-1.434 3.311-3.757 3.311-6.396 0-4.359-3.546-7.893-7.923-7.893-4.376 0-7.922 3.534-7.922 7.893 0 2.565 1.248 4.824 3.152 6.266v23.62h9.383v-6.776c3.025-.6 5.836-1.78 8.327-3.415l4.785 4.817 6.652-6.628-4.746-4.782a23.4 23.4 0 0 0 3.515-8.338z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#151F28",
    d: "M61.322 70.84 52.38 91.862h6.25l1.677-4.253h8.791l1.644 4.253h6.25L68.08 70.84h-6.76zm3.408 5.424 2.963 7.676h-5.954zM82.205 87.79h1.675c2.123 0 3.528-1.616 3.528-3.921 0-2.487-1.345-3.985-3.559-3.985h-1.644v7.905zm1.613-11.977c7.42 0 9.004 5.3 9.004 8.056 0 3.084-1.735 7.994-9.004 7.994h-6.816v-16.05zm14.665 0 5.471 6.048 5.445-6.048h3.739v16.05h-5.206v-7.907c-1.254 1.469-2.482 2.935-3.736 4.373h-.512l-3.827-4.373v7.907h-5.084v-16.05zm17.498 16.049h5.204v-16.05h-5.204zm12.605-16.049 6.192 7.364v-7.364h5.201v16.05h-4.275l-6.52-7.876v7.876h-5.203v-16.05z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    fill: "#000",
    filter: "url(#a)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    fill: "url(#c)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosAdminVertical);
export default __webpack_public_path__ + "static/media/logos-admin-vertical.fe690656d686aa36efa54c29ef5ce064.svg";
export { ForwardRef as ReactComponent };